export function opposite(number) {
  const absNumber = Math.abs(number);
  if (!number) {
    return <div>0</div>;
  }
  if (number > 0) {
    return (
      <div>
        <div
          className="scorecardItem--result semibold"
          style={{
            color: "rgba(52, 199, 89, 1)",
            fontWeight: "600",
          }}
        >
          +{absNumber}
        </div>
      </div>
    );
  }
  if (number === 0) {
    return (
      <div
        className="scorecardItem--result semibold"
        style={{
          color: "#FF3B30",
          fontWeight: "600",
        }}
      >
        {absNumber}
      </div>
    );
  }
  return (
    <div>
      <div
        className="scorecardItem--result semibold"
        style={{
          color: "#FF3B30",
          fontWeight: "600",
        }}
      >
        -{absNumber}
      </div>
    </div>
  );
}
